
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M4.894 4.895h18.284L4.893 23.178z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M7.191 18.794V7.778h11.016M7.286 7.839l15.379 15.173"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M42.6 43.428H24.315l18.283-18.284z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M40.302 29.527v11.016H29.286M40.207 40.484 24.828 25.311"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M42.6 4.895H24.315l18.283 18.283z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M40.302 18.794V7.778H29.286M40.208 7.839 24.829 23.012"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M4.894 43.428h18.284L4.893 25.144z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M7.191 29.528v11.016h11.016M7.286 40.483l15.379-15.172"}})])
          )
        }
      }
    